import { type CSSProperties, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import styles from "./App.module.css";
import { AppProviders } from "./providers/AppProviders";
import { AppRoutes } from "./routing/AppRoutes";
import { resolveBrowserRouterBasename } from "./routing/resolveBrowserRouterBasename";
import { YSTNJ_CURRENT_THEME_TAILWIND_OVERRIDES } from "./theme/current-theme-overrides";
import { syncYstnjNightModeFromProviderAuthority } from "./theme/nightMode";

function App() {
  const basename =
    typeof window === "undefined"
      ? "/"
      : resolveBrowserRouterBasename(window.location.pathname);

  useEffect(() => {
    // External drops + UA-styled inputs can render unreadably when `color-scheme` includes `dark`
    // (ex: OS theme is dark). Force light for now to avoid black/unreadable form controls.
    try {
      document.documentElement.style.colorScheme = "light";
    } catch {
      // ignore
    }
    syncYstnjNightModeFromProviderAuthority();
  }, []);

  return (
    <BrowserRouter basename={basename}>
      <AppProviders>
        <div
          className={styles.root}
          data-ystnj-theme="tailwind-overrides-current"
          data-extracted-from="owned:ystnj/app-root"
          style={YSTNJ_CURRENT_THEME_TAILWIND_OVERRIDES as CSSProperties}
        >
          <AppRoutes />
        </div>
      </AppProviders>
    </BrowserRouter>
  );
}

export default App;
